import { Snippet } from "../../../../pages/components/Snippet";
import { Placeholder, PlaceholderLine, PlaceholderMedia, Fade, ShineOverlay, Shine, Loader, Progressive } from "rn-placeholder";
import React from 'react';
export default {
  Snippet,
  Placeholder,
  PlaceholderLine,
  PlaceholderMedia,
  Fade,
  ShineOverlay,
  Shine,
  Loader,
  Progressive,
  React
};